import { instance } from './Axios';

export const login = async () => {
  const response = await instance.post(`/login`);
  return response.data;
};
